module.exports = __webpack_public_path__ + "static/img/sport_bg4.07eea857.jpg";